import { render, staticRenderFns } from "./ServicesModal.vue?vue&type=template&id=18b87c78&scoped=true"
import script from "./ServicesModal.vue?vue&type=script&lang=js"
export * from "./ServicesModal.vue?vue&type=script&lang=js"
import style0 from "./ServicesModal.vue?vue&type=style&index=0&id=18b87c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b87c78",
  null
  
)

export default component.exports